export const getHairDescription = (hair: boolean, hairColor: string, hairLength: string, hairTexture: string, hairStyle: string): string => {
  // return `${hairLength} ${hairColor} ${hairTexture} ${hairStyle}`.trim();
  // if hairLength is bald or shaved, then hairColor, hairTexture, and hairStyle are not applicable

  if (typeof hair === 'boolean' && !hair) {
    return getHairLengthDescription('Bald');
  }

  if (hairLength === 'Bald' || hairLength === 'Shaved') {
    return getHairLengthDescription(hairLength);
  }

  // Old format:
  // return `${hairLength} ${hairColor} ${hairStyle === 'My Hairstyle' ? '' : `${hairTexture} ${hairStyle}`} hair`.trim();

  // New format:
  // First mention the hairstyle if it exists and isn't "My Hairstyle"
  const hairstyleDescription = hairStyle && hairStyle !== 'My Hairstyle' ? `${hairStyle} hairstyle, ` : '';
  
  // Then describe the hair characteristics
  const hairCharacteristics = `${hairLength} ${hairColor} ${hairTexture}`.trim();

  // Only return hair description if we have actual hair characteristics or hairstyle
  if (!hairstyleDescription && !hairCharacteristics) {
    return '';
  }

  return `${hairstyleDescription}${hairCharacteristics} hair`.trim();
};

export const getHairLengthDescription = (hairLength: string | undefined): string => {
  switch (hairLength) {
    case 'Bald':
      return 'with a bald head';
    case 'Shaved':
      return 'with a shaved head';
    default:
      return '';
  }
};